export default {
	setCareers(state, careers) {
		state.careers = careers
	},
}
